import {RouteObject, Navigate} from 'react-router';

// The public Directory page has been removed — its content is fully covered by
// the Opportunities module. Any /directory* URL now redirects to /opportunities
// so old links/bookmarks don't 404. (The /admin/directory management section is
// separate and unaffected.)
export const directoryRoutes: RouteObject[] = [
  {
    path: 'directory',
    element: <Navigate to="/opportunities" replace />,
  },
  {
    path: 'directory/*',
    element: <Navigate to="/opportunities" replace />,
  },
];
